import { render, staticRenderFns } from "./ViewTotais.vue?vue&type=template&id=2d5908ec"
import script from "./ViewTotais.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewTotais.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ViewTotais.vue?vue&type=style&index=0&id=2d5908ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports